import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Link from "cms/components/front-office/contents/Link";
var LogoHeader = function (props) {
    return (_jsx(Link, { url: "/", sx: { height: "60px" }, title: "Retour vers l'accueil de M.I.A Seconde", children: props.logo || _jsx(Box, { component: "img", alt: "logo", src: "/Logo-header.jpeg", sx: { width: "100%", height: "100%" } }) }));
};
export default LogoHeader;
